module.exports = "<div class=\"layout-container\">\r\n  <div class=\"layout\">\r\n    <psm-section class=\"w-100 h-100\" [id]=\"0\"></psm-section>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/layouts/layouts/fullscreenLayout/fullscreenLayout.component.html
// module id = ./src/app/views/presentations/layouts/layouts/fullscreenLayout/fullscreenLayout.component.html
// module chunks = main